export default __webpack_public_path__ + "static/media/zelle.cdfc9737.svg";